export const scrollToTop = () => {
  const basepageNode = document.querySelector("#basepage");

  if (basepageNode) {
    basepageNode.scrollTo(0, 0);
  }
};
